import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, map, tap } from 'rxjs';
import { Ticket } from '../tickets-generator.component';
import { HttpClient, HttpParams } from '@angular/common/http';

import { AuthLoginService } from 'src/app/pages/login/services/auth-login.service';
import { environment } from 'src/environments/environment';
import { handleError } from 'src/app/tools/tools';
import { BackendResponse } from 'src/app/interfaces/response.interface';
import { TicketI, TicketResponseI } from 'src/app/interfaces/ticket.interface';
import { UserI } from 'src/app/interfaces/user.interface';
import { direction } from 'html2canvas/dist/types/css/property-descriptors/direction';

@Injectable({
  providedIn: 'root',
})
export class TicketService {
  private tickets: Ticket[] = [];

  private url = environment.url;

  private ticketSelectedSource = new BehaviorSubject<Ticket | null>(null);
  ticketSelected$ = this.ticketSelectedSource.asObservable();

  private ticketSubject = new BehaviorSubject<any>(null);
  form$: Observable<any> = this.ticketSubject.asObservable();

  private AllticketsSubject = new BehaviorSubject<any>(null);
  forms$: Observable<any> = this.AllticketsSubject.asObservable();

  constructor(
    private http: HttpClient,
    private authService: AuthLoginService
  ) {}

  selectTicket(ticket: Ticket) {
    this.ticketSelectedSource.next(ticket);
  }

  getTickets(): Observable<Ticket[]> {
    return this.http.get<Ticket[]>(`${this.url}tickets`);
  }

  delegateTicket(ticketId: number, usuarioSoporte: string): Observable<void> {
    return this.http.put<void>(`${this.url}tickets/${ticketId}/delegate`, {
      usuarioSoporte,
    });
  }

  private getFechaActual(): string {
    const fecha = new Date();
    const minutos =
      fecha.getMinutes() < 10 ? '0' + fecha.getMinutes() : fecha.getMinutes();
    return `${fecha.getDate()}/${
      fecha.getMonth() + 1
    }/${fecha.getFullYear()} ${fecha.getHours()}:${minutos}`;
  }

  crearTicket(nuevoTicket: any): Observable<any> {
    return this.http.post<any>(`${this.url}tickets`, nuevoTicket);
  }

  getAllTicketForms(params: HttpParams): Observable<any> {
    let direction = `${this.url}tickets/form/format`;
    return this.http.get<any>(direction, { params }).pipe(
      catchError((error) => handleError(error)),
      tap((data) => (this.ticketSubject = data.result.entities))
    );
  }
  public addTicket(logistic: any | undefined): Observable<any> {
    let direction = this.url + 'tickets';
    return this.http
      .post<any>(direction, logistic)
      .pipe(catchError((error) => handleError(error)));
  }

  getAlltickets$(params: HttpParams) {
    return this.getAlltickets(params);
  }
  getAlltickets(params: HttpParams): Observable<any> {
    let direction = this.url + 'tickets';
    return this.http
      .get<any>(direction, { params })
      .pipe(catchError((error) => handleError(error)));
  }
  getAllSupervisores(): Observable<any> {
    let direction = this.url + 'ticket-supervisor';
    return this.http
      .get<any>(direction)
      .pipe(catchError((error) => handleError(error)));
  }
  // getAllPermissiontickets(params: HttpParams): Observable<any> {
  //   let direction = this.url + 'tickets/tickets/permision';
  //   return this.http
  //     .get<any>(direction, { params })
  //     .pipe(catchError((error) => handleError(error)));
  // }

  getOne(id: string) {
    const direction = `${this.url}tickets/${id}`;
    return this.http.get<BackendResponse>(direction).pipe(
      map((data) => data.result as TicketI),
      catchError((e) => handleError(e))
    );
  }

  update(id: string, body: Partial<TicketI>) {
    const direction = `${this.url}tickets/${id}`;
    return this.http.put<BackendResponse>(direction, body).pipe(
      map((data) => data.result as TicketI),
      catchError((e) => handleError(e))
    );
  }

  getSupportUsers() {
    const direction = `${this.url}users/support-users/get-all/`;
    return this.http.get<BackendResponse>(direction).pipe(
      map((data) => data.result as UserI[]),
      catchError((e) => handleError(e))
    );
  }

  insertTicketResponse(body: FormData) {
    const direction = `${this.url}ticket-response`;
    return this.http.post<BackendResponse>(direction, body).pipe(
      map((data) => data.result as TicketResponseI),
      catchError((e) => handleError(e))
    );
  }

  updateTicketResponse(id: string, body: Partial<TicketI>) {
    const direction = `${this.url}ticket-response/${id}`;
    return this.http.put<BackendResponse>(direction, body).pipe(
      map((data) => data.result as TicketI),
      catchError((e) => handleError(e))
    );
  }



  reporteTicket(params: HttpParams) {
    const direction = this.url + 'tickets/reporte/ticket';
    return this.http.get<any>(direction, { params }).pipe(
      map((data) => data.result as any),
      catchError((e) => handleError(e))
    );
  }
}
